import { call, put, select, takeLeading } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $app from 'modules/app';
import * as $auth from 'modules/auth';
import { updateArtsetArtistName } from 'modules/arts/helpers/updateArtsetArtistName';
import * as api from '../api';
import * as actions from '../actions';
import * as selectors from '../selectors';

const UserProfileToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const createUserProfile = function* (data) {
  const { title, description, tags, socialLinks } = data;
  const { id: userId } = yield select($auth.getCurrentUser);
  const tempCoverPhotoUrl = yield select(selectors.getTempCoverPhotoUrl);
  const tempProfilePhotoUrl = yield select(selectors.getTempProfilePhotoUrl);

  const profile = {
    UserId: userId,
    Title: title,
    Description: description,
    Labels: tags.join(','),
    CoverPhotoURL: tempCoverPhotoUrl,
    ProfilePhotoURL: tempProfilePhotoUrl,
    WebsiteUrl: socialLinks.website,
    FbUrl: socialLinks.facebook,
    instaUrL: socialLinks.instagram,
  };

  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  yield call(api.createUserProfile, userId, profile, {
    token,
    publisherId,
  });
};

export const createUserProfileSaga = function* () {
  yield takeLeading(actions.createUserProfile, function* ({ payload }) {
    yield put($ui.setTrue(UI.UserProfile.IsProfileCreating)());

    try {
      const { userProfileData } = payload;
      yield call(createUserProfile, userProfileData);

      yield call(updateArtsetArtistName, userProfileData.title);

      yield put($ui.setFalse(UI.UserProfile.DialogVisible)());

      const currentUser = yield select($auth.getCurrentUser);
      yield put(actions.fetchUserProfile(currentUser.id));

      yield put($app.updateOnboardingSteps());

      const { callbacks } = payload;
      callbacks.onSuccess();
    } catch {
      UserProfileToaster.show({
        icon: 'warning-sign',
        intent: Intent.DANGER,
        message: 'Something went wrong. Please try again later or contact support',
      });
    } finally {
      yield put($ui.setFalse(UI.UserProfile.IsProfileCreating)());
    }
  });
};
